import { render } from "./NewMessages.vue?vue&type=template&id=71bce17a&scoped=true"
import script from "./NewMessages.vue?vue&type=script&lang=js"
export * from "./NewMessages.vue?vue&type=script&lang=js"

import "./NewMessages.vue?vue&type=style&index=0&id=71bce17a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71bce17a"]])

export default __exports__